module.exports = __webpack_public_path__ + "img/25_4.5228517f.png";